var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWidget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.702096 18.3282H19.0779C19.2427 18.3282 19.402 18.2706 19.5284 18.1655C19.7049 18.0177 23.731 14.5542 23.9765 7.07774H4.24122C3.99667 13.8643 0.28878 17.0542 0.250247 17.086C0.0243465 17.2769 -0.0587667 17.5887 0.0428629 17.8661C0.143789 18.1428 0.406817 18.3282 0.702096 18.3282Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 2.85877H19.7811V2.15561C19.7811 1.76184 19.4717 1.45245 19.0779 1.45245C18.6841 1.45245 18.3748 1.76184 18.3748 2.15561V2.85877H14.8121V2.15561C14.8121 1.76184 14.5027 1.45245 14.1089 1.45245C13.7152 1.45245 13.4058 1.76184 13.4058 2.15561V2.85877H9.89V2.15561C9.89 1.76184 9.58061 1.45245 9.18684 1.45245C8.79307 1.45245 8.48368 1.76184 8.48368 2.15561V2.85877H4.9679C4.57413 2.85877 4.26474 3.16816 4.26474 3.56192V5.67139H24V3.56192C24 3.16816 23.6906 2.85877 23.2969 2.85877Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4313 19.2436C20.0495 19.5616 19.5702 19.7346 19.0779 19.7346H4.26473V21.8441C4.26473 22.2328 4.57923 22.5473 4.96789 22.5473H23.2968C23.6855 22.5473 24 22.2328 24 21.8441V13.9619C22.6443 17.2879 20.7525 18.9748 20.4313 19.2436Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWidget);
export default __webpack_public_path__ + "static/media/calendar-widget.31abb17cb6da2e40d9d8e6106f3df4af.svg";
export { ForwardRef as ReactComponent };